import { capitalize, flatten } from 'lodash/fp';

import ApiResponseError from 'lib/errors/ApiResponseError';
import { Permission } from 'lib/permissions';

export const isPermissionsError = (error: ApiResponseError | undefined) => {
  return error?.status === 403 && error?.errors?.[0]?.code === 'missing_permissions_error';
};

export const isConflictError = (error: ApiResponseError | undefined) => {
  return error?.status === 409;
};

export const isTooManyRequestsError = (error: ApiResponseError | undefined) => {
  return error?.status === 429;
};

export const conflictErrorString = (error: ApiResponseError | undefined) => {
  return (error?.errors?.[0].details as string) ?? 'Account type already exists with this name';
};

const permissionNameFromPermissionsError = (error: ApiResponseError | undefined) => {
  return error?.errors?.[0].details;
};

export const permissionErrorString = (permission: Permission) => {
  if (permission != null) {
    const name = capitalize(
      flatten(permission.split('-').map((substring) => substring.split('.'))).join(' '),
    );

    return `You don't have permissions for an action on this page: ${name}`;
  } else {
    return "You don't have permissions for an action on this page.";
  }
};

export const permissionsErrorMessage = (error: ApiResponseError) => {
  return permissionErrorString(permissionNameFromPermissionsError(error) as Permission);
};
